import React from 'react';
import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { IconButton } from '@goodfynd/react-web.lib.ui';
import type { TextFieldProps } from '@mui/material/TextField';
import TextField from '@mui/material/TextField';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import config from '../../../config';
import { StyledFlex } from '../../styles';
import { StyledContainer } from '../styles';
import type { InputProps } from '../types';

export default function InputDate<T extends FieldValues>({
  control,
  css,
  datePickerProps,
  defaultValue,
  helperText,
  label,
  name,
  onClear,
  ...props
}: InputProps<T>) {
  return (
    <StyledContainer css={css}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Controller
          control={control}
          defaultValue={defaultValue ?? null}
          name={name}
          render={({ field, fieldState: { error } }) => (
            <DatePicker
              {...props}
              {...datePickerProps}
              disableMaskedInput
              inputFormat={config.dateFormats.monthDayYear}
              label={label}
              InputProps={{
                'aria-label': label || 'Choose Date',
              }}
              renderInput={(
                props: JSX.IntrinsicAttributes & TextFieldProps
              ) => (
                <StyledFlex>
                  <TextField
                    {...props}
                    error={!!error}
                    helperText={error?.message || helperText}
                    variant="outlined"
                  />
                  {onClear && field.value && (
                    <IconButton icon="close" onClick={onClear} />
                  )}
                </StyledFlex>
              )}
              rifmFormatter={(val: string) =>
                val.replace(/[^[a-zA-Z0-9-]*$]+/gi, '')
              }
              {...field}
            />
          )}
        />
      </LocalizationProvider>
    </StyledContainer>
  );
}
